function JobOpenIconCompaniesPage() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1106_4035)">
        <path
          d="M19 4H14.6667V2.66667C14.6655 1.74658 13.9201 1.00114 13 1H7C6.07992 1.00114 5.33447 1.74658 5.33333 2.66667V4H1C0.447754 4 0 4.44775 0 5V12.4199C0.00211588 12.8428 0.268555 13.2189 0.666667 13.361V18C0.666667 18.5522 1.11442 19 1.66667 19H18.3333C18.8856 19 19.3333 18.5522 19.3333 18V13.3613C19.7314 13.2191 19.998 12.8428 20 12.4199V5C20 4.44775 19.5522 4 19 4ZM6 2.66667C6 2.11442 6.44775 1.66667 7 1.66667H13C13.5522 1.66667 14 2.11442 14 2.66667V4H13.3333V2.66667C13.3333 2.48258 13.1841 2.33333 13 2.33333H7C6.81592 2.33333 6.66667 2.48258 6.66667 2.66667V4H6V2.66667ZM12.6667 4H7.33333V3H12.6667V4ZM18.6667 18C18.6667 18.1841 18.5174 18.3333 18.3333 18.3333H1.66667C1.48258 18.3333 1.33333 18.1841 1.33333 18V13.4756L8.66667 14.487V15.3333C8.66667 15.8856 9.11442 16.3333 9.66667 16.3333H10.3333C10.8856 16.3333 11.3333 15.8856 11.3333 15.3333V14.487L18.6667 13.4756V18ZM10.6667 15.3333C10.6667 15.5174 10.5174 15.6667 10.3333 15.6667H9.66667C9.48258 15.6667 9.33333 15.5174 9.33333 15.3333V13.3333C9.33333 13.1493 9.48258 13 9.66667 13H10.3333C10.5174 13 10.6667 13.1493 10.6667 13.3333V15.3333ZM19.3333 12.4199C19.3335 12.5861 19.2113 12.7271 19.0467 12.7503L18.9543 12.763L11.3333 13.814V13.3333C11.3333 12.7811 10.8856 12.3333 10.3333 12.3333H9.66667C9.11442 12.3333 8.66667 12.7811 8.66667 13.3333V13.814L0.953613 12.7503C0.789062 12.7272 0.666504 12.5863 0.666667 12.4199V5C0.666667 4.81592 0.815918 4.66667 1 4.66667H19C19.1841 4.66667 19.3333 4.81592 19.3333 5V12.4199Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1106_4035">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default JobOpenIconCompaniesPage;
